import { render, staticRenderFns } from "./lybk.vue?vue&type=template&id=37057937&scoped=true"
import script from "./lybk.vue?vue&type=script&lang=js"
export * from "./lybk.vue?vue&type=script&lang=js"
import style0 from "./lybk.vue?vue&type=style&index=0&id=37057937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37057937",
  null
  
)

export default component.exports